/* eslint-disable react-hooks/exhaustive-deps */
import { StatusCode } from '@/api/enumerations';
import { listAcceptanceDocuments } from '@/api/theHive/notices';
import { AcceptanceDocData } from '@/api/theHive/notices/types';
import useErrorMessage from '@/hooks/useErrorMessage';
import useSnackbar from '@/hooks/useSnackbar';
import { useCallback, useState } from 'react';

export interface UseAcceptanceDocsReturn {
  acceptanceDocs: AcceptanceDocData[];
  isLoading: boolean;
  fetchAcceptanceDocuments: () => Promise<void>;
}

export function useAcceptanceDocs(noticeId?: number): UseAcceptanceDocsReturn {
  const [acceptanceDocs, setAcceptanceDocs] = useState<AcceptanceDocData[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const { getErrorMessage } = useErrorMessage();
  const { handleSnackbar } = useSnackbar();

  const fetchAcceptanceDocuments = useCallback(async () => {
    if (!noticeId) return;

    try {
      setIsLoading(true);
      const response = await listAcceptanceDocuments(noticeId);
      if (response.detail.description) {
        throw new Error(response.detail.description);
      }

      if (response.detail.status_code !== StatusCode.OK) {
        throw new Error('Algo deu errado, tente novamente.');
      }
      setAcceptanceDocs(response.data || []);
    } catch (error) {
      handleSnackbar(getErrorMessage(error), false);
    } finally {
      setIsLoading(false);
    }
  }, [noticeId]);

  return {
    isLoading,
    acceptanceDocs,
    fetchAcceptanceDocuments,
  };
}
